import React, { useState } from 'react';
import { IoCopyOutline, IoCheckmarkSharp } from 'react-icons/io5';

export function CopiableText({ metadata, darkMode }) {
    const [copied, setCopied] = useState(false);

    if (!metadata || !metadata.textToCopy) return null;

    const handleCopy = () => {
        navigator.clipboard.writeText(metadata.textToCopy).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    };

    return (
        <div className={`tw-mt-2 tw-mb-1 tw-rounded-2xl tw-border tw-overflow-hidden ${
            darkMode ? 'tw-border-white/10' : 'tw-border-gray-200'
        }`}>
            <div className={`tw-px-3 tw-py-1.5 tw-flex tw-items-center tw-justify-between ${
                darkMode ? 'tw-bg-white/5' : 'tw-bg-gray-50'
            }`}>
                <span className={`tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wider ${
                    darkMode ? 'tw-text-gray-400' : 'tw-text-gray-500'
                }`}>
                    {metadata.label || 'Code'}
                </span>
                {copied && metadata.successMessage && (
                    <span className="tw-text-[10px] tw-text-green-500 tw-font-medium">
                        {metadata.successMessage}
                    </span>
                )}
            </div>
            <div className={`tw-flex tw-items-center tw-justify-between tw-px-3 tw-py-2.5 tw-gap-3 ${
                darkMode ? 'tw-bg-white/[0.03]' : 'tw-bg-white'
            }`}>
                <code className={`tw-text-sm tw-font-bold tw-font-mono tw-tracking-wide tw-select-all ${
                    darkMode ? 'tw-text-white' : 'tw-text-gray-900'
                }`}>
                    {metadata.textToCopy}
                </code>
                <button
                    onClick={handleCopy}
                    className={`tw-flex-none tw-w-8 tw-h-8 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-border-0 tw-cursor-pointer tw-transition-colors ${
                        copied
                            ? darkMode
                                ? 'tw-bg-green-500/20 tw-text-green-400'
                                : 'tw-bg-green-50 tw-text-green-600'
                            : darkMode
                                ? 'tw-bg-white/10 tw-text-gray-300 hover:tw-bg-white/15'
                                : 'tw-bg-gray-100 tw-text-gray-600 hover:tw-bg-gray-200'
                    }`}
                    aria-label="Copy to clipboard"
                    title="Copy to clipboard"
                >
                    {copied ? (
                        <IoCheckmarkSharp size={16} />
                    ) : (
                        <IoCopyOutline size={16} />
                    )}
                </button>
            </div>
        </div>
    );
}
